/**
 * Ключи в `add_info` позиции корзины (temp_cart), которые ЛК проставляет при
 * добавлении и читает обратно в журнале-корзине. `add_info` — свободный JSON.
 *
 * Имя ключа следует конвенции платформы (см. Postman /TempCart и
 * journalDocuments.ts): `e1<Name>` — отображаемая строка, `e0<Name>` —
 * служебные идентификаторы. Ключ без префикса (`selection_name`) в корзине не
 * сохранялся — в ответе приходил `add_info: null`, и колонка «Подбор» была
 * пустой, хотя запрос уходил с названием (CAB-601).
 */

/** Название подбора, из которого позиция отобрана в корзину (колонка «Подбор»). */
export const SELECTION_NAME_ADD_INFO_KEY = "e1SelectionName";

/** Прежний ключ без префикса — читаем для позиций, добавленных до смены имени. */
export const SELECTION_NAME_ADD_INFO_KEY_LEGACY = "selection_name";

/**
 * UUID рекомендательной позиции — его проставляет БЭК при оформлении заказа из КП
 * (`POST zakooper/recommendation_items/make_order`). Название подбора он при этом
 * не кладёт, поэтому для таких строк колонка «Подбор» разрешается через этот ключ.
 */
export const RECOMMENDATION_ITEM_ADD_INFO_KEY = "e0RecommendationItemUUID";

/**
 * Профиль, положивший позицию в корзину, — колонка «Ответственный» (CAB-745).
 *
 * Нужен, пока у строки нет заказа. Ответственного мы берём из подробностей
 * позиции (`order_info.prid`), но у строки в состоянии «Оформлено» номера заказа
 * ещё нет, спрашивать `order_info` не о чем, и колонка пустует — именно это
 * увидели на прогоне 23.09.2026 (AUT-235). Свой ключ в `add_info` едет вместе со
 * строкой с самого добавления в корзину и оформление переживает, поэтому он
 * закрывает промежуток без единого дополнительного запроса.
 *
 * Заказы не из корзины ЛК (1С, API, КП) ключа не несут — их ответственный
 * приходит в `prid`, который бэк для них заполняет.
 */
export const RESPONSIBLE_PROFILE_ID_ADD_INFO_KEY = "e0ResponsibleProfileID";

/**
 * Подпись профиля на момент добавления — запасной вариант к идентификатору.
 *
 * `auth/client/profiles` отдаёт не все профили клиента (замер 23.09.2026: 57
 * записей, а в заказах встречаются идентификаторы, которых в списке нет).
 * Сохранённая подпись оставляет колонку заполненной, даже когда справочник
 * профиля не знает.
 */
export const RESPONSIBLE_NAME_ADD_INFO_KEY = "e1Responsible";
